import { Button } from 'antd';
import styled from 'styled-components';

export const CodeContainer = styled.div`
    position: relative;
    border: 1px solid #D9D9D9;
    padding: 8px 16px;
    border-radius: 6px;
    background-color: #FFFFFF;
`;

export const InnerContainer = styled.div`
    top:0;
    left: 0;
    position: absolute;
    backdrop-filter: blur(4px);
    cursor: not-allowed;
    width: 100%;
    height: 100%;
    z-index: 99;
`;

export const ExecuteButton = styled(Button)`
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2
`;

export const PreviewButton = styled(Button)`
    position: absolute;
    top: 5px;
    right: 63px;
    z-index: 2
`;

export const SQLPreviewModal = styled.div`
    max-height: 600px;
    overflow: auto;
    scrollbar-width: thin;
`;